var _circle, _circle2, _circle3, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoveDataBrokerGroupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.9483,
    cy: 21.0519,
    r: 15.3103,
    fill: "white",
    stroke: "#2C6FC4",
    strokeWidth: 1.27586
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.4999,
    r: 15.3103,
    fill: "white",
    stroke: "#2C6FC4",
    strokeWidth: 1.27586
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.0518,
    cy: 15.9484,
    r: 15.3103,
    fill: "white",
    stroke: "#2C6FC4",
    strokeWidth: 1.27586
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5706 10.98V9.29485C24.5706 8.90409 24.7538 8.63543 25.1201 8.48889C25.4865 8.34236 25.804 8.40341 26.0726 8.67207L29.2232 11.8226C29.3453 11.9447 29.4186 12.0791 29.443 12.2256C29.4918 12.3721 29.4918 12.5187 29.443 12.6652C29.4186 12.8118 29.3453 12.9461 29.2232 13.0682L26.0726 16.2188C25.804 16.4874 25.4865 16.5485 25.1201 16.4019C24.7538 16.2554 24.5706 15.9867 24.5706 15.596V13.9108H13.507C13.2139 13.9108 13.0674 13.7643 13.0674 13.4712V11.4196C13.0674 11.1266 13.2139 10.98 13.507 10.98H24.5706Z",
    fill: "#5596F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0131 21.634V23.3192C18.0131 23.7099 17.83 23.9786 17.4636 24.1251C17.0973 24.2717 16.7798 24.2106 16.5111 23.942L13.3606 20.7914C13.1896 20.6204 13.1041 20.4128 13.1041 20.1686C13.1041 19.9244 13.1896 19.7168 13.3606 19.5458L16.5111 16.3953C16.7798 16.1266 17.0973 16.0656 17.4636 16.2121C17.83 16.3586 18.0131 16.6273 18.0131 17.0181V18.7032H29.0767C29.3698 18.7032 29.5164 18.8498 29.5164 19.1429V21.1944C29.5164 21.4875 29.3698 21.634 29.0767 21.634H18.0131Z",
    fill: "#2C6FC4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveDataBrokerGroupIcon);
export default __webpack_public_path__ + "static/media/move-data-broker-group-icon.089374de6d55c980821538bb8930f0e9.svg";
export { ForwardRef as ReactComponent };